"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _detail = _interopRequireDefault(require("./detail.vue"));
var _permission = require("@/utils/permission");
var _group = require("@/api/group");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 权限判断函数
var _default = exports.default = {
  components: {
    activityDetail: _detail.default
  },
  data: function data() {
    return {
      tableData: [],
      formData: {
        page: 1,
        limit: 20,
        groupName: '',
        groupProcess: '',
        activityStatus: '',
        startTime: '',
        groupStatus: '4'
      },
      total: 0,
      countArr: [],
      groupProcessArr: ['未开始', '进行中', '已结束']
    };
  },
  created: function created() {
    this.$route.params.type && (this.formData.groupStatus = this.$route.params.type);
    if ((0, _permission.checkPermi)(['merchant:groupbuy:activity:list'])) this.getData();
  },
  methods: {
    checkPermi: _permission.checkPermi,
    search: function search() {
      this.formData.page = 1;
      this.getData();
    },
    totalOrderDoneHeader: function totalOrderDoneHeader(h, _ref) {
      var column = _ref.column;
      return this.headerText(h, column, '成团订单数：此拼团活动用户已经拼团成功的所有成功订单数统计（不包含未支付的订单数据）');
    },
    totalOrderBeginHeader: function totalOrderBeginHeader(h, _ref2) {
      var column = _ref2.column;
      return this.headerText(h, column, '参团订单数：此拼团活动用户开团的所有订单数统计（不包含未支付的订单数据）');
    },
    totalActivityDoneHeader: function totalActivityDoneHeader(h, _ref3) {
      var column = _ref3.column;
      return this.headerText(h, column, '成团数：此拼团活动用户已经拼团成功的团次数统计');
    },
    // 开团提示
    totalActivityBeginHeader: function totalActivityBeginHeader(h, _ref4) {
      var column = _ref4.column;
      return this.headerText(h, column, '开团数：此拼团活动用户开团的次数统计');
    },
    headerText: function headerText(h, column, text) {
      var serviceContent = [h('div', {
        slot: 'content'
      }, text)];
      return h('div', [h('span', column.label), h('el-tooltip', {
        props: {
          placement: 'top'
        }
      }, [serviceContent, h('i', {
        class: 'el-icon-warning-outline',
        style: 'color:#999;margin-left:5px;'
      })])]);
    },
    //撤回
    rollback: function rollback(row) {
      var _this = this;
      this.$modalSure('要撤回此活动吗？').then(function () {
        (0, _group.groupbuyActivityRollback)(row.id).then(function (res) {
          _this.$message({
            type: 'success',
            message: '撤回成功!'
          });
          _this.getData();
        });
      });
    },
    timeChange: function timeChange(e) {
      this.formData.page = 1;
      this.getData();
    },
    handleClick: function handleClick(tab, event) {
      this.formData.page = 1;
      this.getData();
    },
    selectChange: function selectChange() {
      this.formData.page = 1;
      this.getData();
    },
    //活动状态开关
    changeStatus: function changeStatus(row, e) {
      var _this2 = this;
      (0, _group.groupActivityStatus)({
        id: row.id,
        status: e
      }).then(function (res) {
        _this2.$message({
          type: 'success',
          message: '修改成功!'
        });
      });
    },
    getData: function getData() {
      var _this3 = this;
      (0, _group.groupBuyList)(this.formData).then(function (res) {
        _this3.tableData = res.list;
        _this3.total = res.total;
        _this3.getCount();
      });
    },
    getCount: function getCount() {
      var _this4 = this;
      (0, _group.groupBuyListCount)(this.formData).then(function (res) {
        _this4.countArr = res;
      });
    },
    //详情
    toDeatil: function toDeatil(row) {
      var _this5 = this;
      (0, _group.groupBuyInfo)(row.id).then(function (res) {
        _this5.$refs.detail.groupInfo = res;
        _this5.$refs.detail.dialogVisible = true;
      });
    },
    //关闭
    delGroup: function delGroup(row) {
      var _this6 = this;
      this.$modalSure('要删除此活动吗？').then(function () {
        (0, _group.groupBuyDelete)(row.id).then(function (res) {
          _this6.$message({
            type: 'success',
            message: '删除成功!'
          });
          _this6.getData();
        });
      });
    },
    //添加活动
    toAdd: function toAdd() {
      this.$router.push({
        path: '/marketing/group/createGroup'
      });
    },
    //编辑活动  type=1编辑 2 复制
    toUpdate: function toUpdate(row) {
      this.$router.push({
        path: "/marketing/group/createGroup/".concat(row.id, "/1")
      });
    },
    toCopy: function toCopy(row) {
      this.$router.push({
        path: "/marketing/group/createGroup/".concat(row.id, "/2")
      });
    },
    handleSizeChange: function handleSizeChange(val) {
      this.formData.limit = val;
      this.getData();
    },
    pageChange: function pageChange(page) {
      this.formData.page = page;
      this.getData();
    },
    //重置
    reset: function reset() {
      this.formData.page = 1;
      this.formData.groupName = '';
      this.formData.groupProcess = '';
      this.formData.activityStatus = '';
      this.formData.startTime = '';
      this.formData.groupStatus = '4';
      this.getData();
    }
  }
};